module.exports = __webpack_public_path__ + "img/couples-074.3b172124.jpg";